<template>
  <v-app>
    <navigation />

    <app-header />

    <v-main>
      <v-container fluid>
        <v-list>
          <v-subheader>Feature Toggles</v-subheader>
          <v-list-item v-for="toggle in featureToggles" :key="toggle.id">
            <v-checkbox
              :disabled="isLoading"
              :label="toggle.name"
              v-model="toggle.enabled"
              hint="Overridden locally"
              :persistent-hint="toggle.isLocalOverride"
              @change="(enabled) => featureToggleChange(toggle.id, enabled)"
            >
              <template v-slot:append v-if="toggle.isLocalOverride">
                <v-icon
                  @click="() => clearFeatureToggleOverride(toggle.id)"
                  title="Sync with server"
                >
                  mdi-sync
                </v-icon>
              </template>
            </v-checkbox>
          </v-list-item>
        </v-list>
      </v-container>
    </v-main>
    <app-footer />
  </v-app>
</template>

<script>
import Navigation from '@/components/main/Navigation';
import AppHeader from '@/components/main/Header';
import AppFooter from '@/components/main/Footer';
import { ConstantsTypesMap } from '@/constants';
import { fetchConstants } from '@/api';
import { ACTIONS } from '@/store';

export default {
  data() {
    return {
      isLoading: false
    };
  },
  created() {
    if (!this.$store.state.constants) {
      this.getConstants();
    }
  },
  components: {
    Navigation,
    AppHeader,
    AppFooter
  },
  computed: {
    featureToggles: {
      get() {
        return this.$store.getters.getConstantsByType(
          ConstantsTypesMap.FEATURE_TOGGLE
        );
      }
    }
  },
  methods: {
    async getConstants() {
      this.isLoading = true;
      const constants = await fetchConstants();
      this.isLoading = false;
      this.$store.dispatch(ACTIONS.SET_CONSTANTS, constants);
    },
    featureToggleChange(toggleId, enabled) {
      this.$store.dispatch(ACTIONS.OVERRIDE_FEATURE_TOGGLE, {
        toggleId,
        enabled
      });
    },
    clearFeatureToggleOverride(toggleId) {
      this.featureToggleChange(toggleId);
      // Reload server constant values
      this.getConstants();
    }
  }
};
</script>
